import { Component, Input, SimpleChanges } from '@angular/core';
import { DynamicComponent } from '@dice/app/types/dynamic-component.type';
import { DetailsContent, RowContent } from '@dice/app/types/table.types';

@Component({
  selector: 'table-column',
  templateUrl: './table-column.component.html',
  standalone: false,
})
export class TableColumnComponent<T> {
  @Input() element?: T;

  @Input() table?: RowContent | DetailsContent;

  cssClass: string[];

  dynamicComponent: DynamicComponent;

  ngOnChanges(changes: SimpleChanges): void {
    const { table, element } = changes;
    if (!!table && table.firstChange && !!element) {
      this.createDynamicComponent();
    }
  }

  createDynamicComponent(): void {
    const { element } = this;
    const isHeader = false;
    const inputs = { element, isHeader, ...this.table };
    const outputs = {};
    const { type } = this.table;
    const component = type;
    this.dynamicComponent = { type, component, inputs, outputs };
  }
}
